import React from 'react';
import { FIRMA } from '../data/firma';
import s from '../css/modules/Landing.module.css';

/**
 * Blok autora / prowadzacej (spec sekcja 9).
 * Widoczne nazwisko i kwalifikacje zamiast anonimowego konta "admin".
 */
export default function AuthorBox({ compact = false }) {
  return (
    <aside className={s.authorBox}>
      <img
        src="/image/anna-sensorini-olsztyn-terapia-dla-dziecka-Anna.webp"
        alt={`${FIRMA.osoba}, terapeutka integracji sensorycznej w Olsztynie`}
        width="128"
        height="128"
        loading="lazy"
      />
      <div>
        <p>
          <strong>{FIRMA.osoba}</strong>
          <br />
          {FIRMA.rola}.
        </p>
        {!compact && (
          <p>
            Pedagog i nauczycielka wczesnoszkolna z wieloletnim doświadczeniem, certyfikowana
            terapeutka i diagnostka integracji sensorycznej, specjalistka resocjalizacji. Prowadzi
            terapię ręki i Trening Umiejętności Społecznych, współpracuje z fizjoterapeutami,
            neurologopedami i psychologami.
          </p>
        )}
        <a href="/o-mnie/">Poznaj kwalifikacje i doświadczenie</a>
      </div>
    </aside>
  );
}
